import { useDripsyTheme } from 'dripsy';

export function useColors() {
  const theme = useDripsyTheme();

  return theme.theme.colors;
}
